import { useState, useEffect } from "react";
import { checkDeviceRequirements } from "../firebase/checkDeviceRequirements";

/**
 * React hook that determines whether the current device/browser meets the
 * app’s baseline requirements.
 *
 * @returns {boolean} `true` when compatible, otherwise `false`.
 */
export default function useDeviceCompatibility() {
  const [isCompatible, setIsCompatible] = useState(true);

  useEffect(() => {
    let isMounted = true; // prevent state updates after unmount

    const runCheck = async () => {
      try {
        const userAgent = navigator.userAgent;
        const result = await checkDeviceRequirements(userAgent);
        if (isMounted) setIsCompatible(result);
      } catch (error) {
        console.error("Device compatibility check failed:", error);
        if (isMounted) setIsCompatible(false);
      }
    };

    runCheck();

    return () => {
      isMounted = false;
    };
  }, []); // run once on mount

  return isCompatible;
}
